import React from "react";
import { buttonBaseClasses, outlinedInputClasses } from "@mui/material";
import { StyledTextField } from "../text-field/HyroTextField.styles";
import ChevronDown from "src/icons/ChevronDown";
import ChipContainer from "src/components/hyro-components/ChipContainer";
import useHyroMultiSelect from "./HyroMultiSelect.hook";
import MultiSelectContent from "./MultiSelectContent";
import styled from "@emotion/styled";

const StyledMultiSelectField = styled(StyledTextField, {
  shouldForwardProp: (prop) => prop !== "showAllChips"
})(({ theme, showAllChips }) => ({
  [`& .${outlinedInputClasses.root}`]: {
    padding: theme.spacing(1),
    lineHeight: "32px",
    [`& .${outlinedInputClasses.input}`]: {
      height: showAllChips ? "auto" : "32px",
      minHeight: "32px",
      lineHeight: "32px",
    }
  }
}));

const HyroMultiSelect = (
  {
    id,
    options,
    label,
    value = [],
    onChange,
    error,
    isReadOnly,
    helperText,
    disabled,
    isFieldReadOnlyFromSpec,
    showLabel,
    testId,
    open = false,
    onFocus,
    onBlur,
    onPopperClose,
    SelectProps = {},
    InputProps = {},
    sx
  }) => {

  const { localValue, textValues, handleBlur, handleFocus, inputRef, menuOpen } = useHyroMultiSelect({
    value,
    options,
    onFocus,
    onBlur,
    onPopperClose,
    open
  });

  return (
    <StyledMultiSelectField
      disabled={disabled}
      readOnly={isReadOnly}
      isFieldReadOnlyFromSpec={isFieldReadOnlyFromSpec}
      showAllChips={isReadOnly}
      data-testid={testId}
      slotProps={{
        input: {
          ...InputProps,
          readOnly: isReadOnly
        },
        select: {
          multiple: true,
          renderValue: () => <ChipContainer values={textValues} testId={testId} isReadOnly={isReadOnly} showAllChips={isReadOnly} />,
          ref: inputRef,
          MenuProps: {
            autoFocus: false,
            sx: { ...MenuSx, ...SelectProps?.MenuProps?.sx },
            elevation: 3,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            },
            PaperProps: {
              style: {
                ...SelectProps?.MenuProps?.PaperProps?.style,
                padding: 0
              }
            }
          },
          IconComponent: (props) => <ChevronDown {...props} style={{ top: "unset", right: 12 }} />,
          open: menuOpen,
          onClose: () => {
            handleBlur();
          },
          onOpen: handleFocus
        },
        formHelperText: {
          "data-testid": `${testId}-helper`
        }
      }}
      label={showLabel ? label : ""}
      error={!!error}
      helperText={helperText ?? ""}
      select
      fullWidth
      sx={sx}
      id={id}
      value={localValue || ""}
    >
      <MultiSelectContent
        testId={testId}
        options={options}
        selectionOptions={localValue}
        onChange={onChange}
      />
    </StyledMultiSelectField>
  );
};

const MenuSx = {
  marginTop: "4px",
  [`.${buttonBaseClasses.root}[aria-selected='true']`]: {
    background: "white"
  },
  [`.${buttonBaseClasses.root}[aria-selected='true']:hover`]: {
    background: "white"
  }
};

export default HyroMultiSelect;
